// typings

import { create } from "zustand";

import { IRecepcaoState } from "@/store-zustand/recepcao/index";

// criação da store com Zustand (Recepcao)
export const useStoreZustandRecepcao = create<IRecepcaoState>((set) => ({
  // estados
  isLoading: false,
  isLoadingPage: false,
  remessasEmRecepcao: [],
  expedicoes: [1],
  paginations: [1],
  itemsPerPage: 10,
  currentPage: 1,
  totalItemsPage: 0,
  searchItem: "",
  lastPage: 1,
  remessaUnicaEmRecepcao: null,

  // ações
  setIsLoading: (isLoading) => set({ isLoading }),
  setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
  setSearchItem: (searchItem) => set({ searchItem }),
  setIsLoadingPage: (isLoadingPage) => set({ isLoadingPage }),
  setPaginations: (paginations) => set({ paginations }),
  setLastPage: (lastPage) => set({ lastPage }),
  setRemessasEmRecepcao: (remessasEmRecepcao) => set({ remessasEmRecepcao }),
  setRemessaUnicaEmRecepcao: (remessaUnicaEmRecepcao) => set({ remessaUnicaEmRecepcao }),
}));
